// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___Azhjk","facultyGraph":"styles__facultyGraph___3e_vf","graphHeading":"styles__graphHeading___BegLT","nodes":"styles__nodes___z0GAp","links":"styles__links___2zZl_","rotate":"styles__rotate___3eW3B","fadein":"styles__fadein___33Pxu","slideFromRight":"styles__slideFromRight___2v7Iu","waves":"styles__waves___YvO4d"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/FacultyGraph/styles.scss
// module id = ./resources/assets/js/components/FacultyGraph/styles.scss
// module chunks = 0